<template>
  <div :class="{ 'pb-alert': true, [latlng]: true }">
    <div
      v-for="(alert, index) in alerts"
      :key="alert.uid"
      :class="`pb-alert-item ${alert.type}`"
      :style="stylus(index)"
    >
      <pb-float float="left">
        {{ alert.content }}
      </pb-float>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { FLOAT_POSITION } from "@/lib/staticValue";

export default {
  name: "PbAlert",
  data: () => ({}),
  props: {
    options: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      alerts: "alerts"
    }),

    latlng() {
      return FLOAT_POSITION[this.$config.position];
    },

    $config() {
      return { ...this.$alert.options, ...this.options };
    }
  },
  methods: {
    ...mapMutations(["ADD_ALERTS", "REMOVE_ALERTS"]),

    stylus(index) {
      const top = /(top)/.test(this.latlng);
      const size = index - this.alerts.length + 1;

      if (top) {
        return {};
      } else {
        return {
          top: `${size * (12 + 48)}px`
        };
      }
    }
  }
};
</script>
<style lang="scss">
@import "~styles/color";

@keyframes alert_slider_up {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  85% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-40px);
  }
}

.pb-alert {
  position: fixed;
  z-index: 1200;
  font-size: 1.4rem;
  width: 400px;
  height: 48px;

  &.top {
    top: calc(2.4vh + 16px);
  }

  &.bottom {
    bottom: calc(2.4vh + 16px);

    .pb-alert-item {
      animation: 3s alert_slider_up alternate ease-out;
    }
  }

  &.left {
    left: calc(1.6vw + 16px);
  }

  &.right {
    right: calc(1.6vw + 16px);
  }

  &.center {
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }

  &-item {
    position: absolute;
    padding: 0 16px;
    width: 400px;
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.13);
    transition: all 0.3s;

    &.error {
      @extend %error_setting;
    }

    &.success {
      @extend %success_setting;
    }

    &.info {
      @extend %info_setting;
    }

    &.warning {
      @extend %warn_setting;
    }
  }
}
</style>
